let debug = false

function log(...arg: any) {
  console.log.call(
    null,
    `%c[ALTIHEX_SDK]`,
    'color:#1bc5bd;font-weight:bold;',
    ...arg
  )
}
log.setDebug = function (type: boolean) {
  debug = type
}
log.debug = function (...arg: any) {
  if (debug && process.env.NODE_ENV !== 'production')
    console.debug.call(
      null,
      `%c[ALTIHEX_SDK_DEBUG]`,
      'color:#2f54eb;font-weight:bold;',
      ...arg
    )
}
log.error = function (...arg: any) {
  console.error.call(
    null,
    `%c[ALTIHEX_SDK_ERROR]`,
    'color:red;font-weight:bold;',
    ...arg
  )
}

export { log }
